/**
 *
 * WARNING : fichier généré par cli, ne pas le modifier directement
 *
 */
import { useCommitMutation } from '@@views/_common/client/hooks/useCommitMutation';
import SaveSimulationRecapMutation from '../graphql/mutations/SaveSimulationRecapMutation.js';

export const useSaveSimulationRecapMutation = () => {
  return useCommitMutation(SaveSimulationRecapMutation, {
    dataProp: 'saveSimulationRecap_M_simulation_recap'
  });
};

export default useSaveSimulationRecapMutation;
